import {PathsWithTarget} from '@yandex-delivery/utils'
import {useController} from 'react-hook-form'

// Типы react-hook-form плохо ложатся с нашими аналогами для получения путей, так что приходится использовать немножко
// кастов, чтобы не сорить ими в коде собираем их в одном месте
export function useTypedField<TForm, TValue>(name: PathsWithTarget<TForm, TValue>) {
  const {
    field: {onChange, value, onBlur, ref},
    fieldState: {error, isTouched},
  } = useController({name})

  return [
    value as TValue,
    onChange as (value: TValue) => void,
    {onBlur, ref, error: isTouched ? error : undefined},
  ] as const
}
